import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["number", "text"]

  increment() {
    this.#update(1)
  }

  decrement() {
    this.#update(-1)
  }

  #update(diff) {
    const data = this.data
    const count = parseInt(data.get("value"), 10) + diff
    data.set("value", count)

    this.element.classList.toggle("hidden", count == 0)
    this.numberTarget.innerText = this.#format(count)

    if (this.hasTextTarget) {
      const text =
        count == 1 ? data.get("textSingular") : data.get("textPlural")
      this.textTarget.innerText = text
    }
  }

  #format(number) {
    const short = number < 1000 ? number : Math.floor(number / 100) / 10
    return new Intl.NumberFormat(document.documentElement.lang).format(short)
  }
}
